<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
    <div class="form-group" [formGroup]="form">
      <app-action-alert controlName="score" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
		<app-text-input label="Score" placeholder="Value" formControlName="score" inputMode="numeric"></app-text-input>
    </div>
    <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
</div>
</app-action-form>

